import { render, staticRenderFns } from "./AprovadasSelo.vue?vue&type=template&id=2cb59a2f&scoped=true"
import script from "./AprovadasSelo.vue?vue&type=script&lang=js"
export * from "./AprovadasSelo.vue?vue&type=script&lang=js"
import style0 from "./AprovadasSelo.vue?vue&type=style&index=0&id=2cb59a2f&prod&lang=css"
import style1 from "./AprovadasSelo.vue?vue&type=style&index=1&id=2cb59a2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb59a2f",
  null
  
)

export default component.exports